"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _componentsWeb = require("@telus-uds/components-web");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../constants");
var _useStepTrackerContext = _interopRequireDefault(require("../hooks/useStepTrackerContext"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var StepTrackerDisplay = props => {
  var {
    language = _constants.CONTENTFUL_LOCALE.en,
    steps = []
  } = props;
  var {
    currentStep,
    stepTrackerDisplayRef
  } = (0, _useStepTrackerContext.default)();
  var stepsLabels = steps.map(step => step.label);
  var dictionary = {
    [language]: steps.reduce((acc, curr, i) => {
      acc[i + 1] = {
        stepLabel: (curr === null || curr === void 0 ? void 0 : curr.overline) || '',
        stepTrackerLabel: (curr === null || curr === void 0 ? void 0 : curr.mobileLabel) || (curr === null || curr === void 0 ? void 0 : curr.label) || ''
      };
      return acc;
    }, {})
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_componentsWeb.StepTracker, {
    ref: stepTrackerDisplayRef,
    copy: language,
    current: currentStep,
    steps: stepsLabels,
    dictionary: dictionary
  }));
};
StepTrackerDisplay.prototype = {
  language: _propTypes.default.string,
  steps: _propTypes.default.array
};
var _default = exports.default = StepTrackerDisplay;